export default __webpack_public_path__ + "static/media/img_6.d39f52fa.png";